<div [class.ig-border-spinner]="item.pinnedTime" class="bg-white" [class.p-4]="item.socialName==='promotion'"
  [class.h-full]="item.socialName==='promotion'" (click)="showDetails()">
  <ng-container *ngIf="item.socialName==='promotion'">
    <ig-image [src]="item?.cover?.source" class="h-full" cls="w-full h-full object-cover cursor-pointer"></ig-image>
  </ng-container>

  <div *ngIf="item.socialName!=='promotion'" class="shadow-md transition-all cursor-pointer hover:shadow-2xl"
    [class.ig-pinned]="item?.pinnedTime">
    <ig-image [src]="item?.cover?.source" [alt]="item?.name" cls="w-full object-cover aspect-[4/3]"></ig-image>

    <ig-event-time *ngIf="getItemType()==='event'" [item]="item"></ig-event-time>

    <div class="p-4 bg-white h-56 relative">
      <div class="text-sm text-gray-600 font-bold mb-2">
        <span *ngIf="!isSearchName">{{item?.title || item?.name}}</span>
        <span *ngIf="isSearchName" [innerHTML]="(item?.title || item?.name)| highlight:keyword"></span>
      </div>
      <div *ngIf="getItemType()==='event'" class="text-sm">
        <mat-icon class="text-sm align-middle">account_balance</mat-icon>
        Hosted by: {{ item?.owner?.name || item?.name }}
      </div>
      <div *ngIf="getItemType()==='place'" class="text-sm">
        <mat-icon class="text-sm align-middle">list</mat-icon>
        <span *ngIf="isSearchCategory" [innerHTML]="getDisplayCategory(item)| highlight:keyword"></span>
        <span *ngIf="!isSearchCategory">{{ getDisplayCategory(item) }}</span>   
      </div>
      <div class="text-sm">
        <mat-icon class="text-sm align-middle">pin_drop</mat-icon>
        <span *ngIf="item?.venue">{{ item.venue }}, </span>
        <span *ngIf="getItemType()==='event'">{{ item.address?.address || (item.isOnlineEvent ? 'Online Event' : '(no
          location)') }}</span>
        <span *ngIf="getItemType()==='place'">
          <span *ngIf="isSearchAddress" [innerHTML]="(item.address?.address || '(no location)')| highlight:keyword"></span>
          <span *ngIf="!isSearchAddress">{{ item.address?.address || '(no location)' }}</span>
        </span>
      </div>

      <div class="absolute bottom-6 right-4 w-[calc(100%-2rem)] h-8">
        <span class="text-red-500 text-sm"
          *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && item?.isChoice">
          <mat-icon class="align-bottom">favorite_border</mat-icon>
          {{ getItemType() === 'event' ? editorChoiceText.editorChoiceForEvent : editorChoiceText.editorChoiceForPlace
          }}
        </span>
        <div
          class="float-right py-2 px-4 rounded-3xl font-semibold text-sm text-white root-detail-btn-bg hover:shadow-lg">
          DETAILS
        </div>
      </div>
    </div>
  </div>
</div>